/* LBM: progressive enhancement. GET search works even when scripts or suggestions fail. */
if (!customElements.get('lbm-product-search')) {
  customElements.define('lbm-product-search', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.input = this.querySelector('input[type="search"]');
      this.panel = this.querySelector('[role="listbox"]');
      this.status = this.querySelector('[data-status]');
      this.clearButton = this.querySelector('.lbm-search-clear');
      if (!this.input || !this.panel || !this.clearButton) return;
      this.sequence = 0; this.active = -1; this.options = [];
      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.setAttribute('aria-haspopup', 'listbox');
      this.input.addEventListener('input', () => this.schedule(), opts);
      this.input.addEventListener('focus', () => { if (this.input.value.trim()) this.schedule(); }, opts);
      this.input.addEventListener('keydown', e => this.key(e), opts);
      this.clearButton.addEventListener('click', () => { this.input.value = ''; this.stop(); this.clearButton.hidden = true; this.input.focus(); }, opts);
      this.querySelector('form').addEventListener('submit', e => {
        if (!this.input.value.trim()) { e.preventDefault(); this.input.focus(); }
      }, opts);
      this.addEventListener('focusout', () => setTimeout(() => { if (!this.contains(document.activeElement)) this.stop(); }, 0), opts);
      document.addEventListener('pointerdown', e => { if (!this.contains(e.target)) this.stop(); }, opts);
    }
    disconnectedCallback() { this.stop(); this.events?.abort(); }
    stop() {
      clearTimeout(this.timer); this.request?.abort(); this.sequence = (this.sequence || 0) + 1;
      if (this.panel) this.panel.hidden = true;
      this.input?.setAttribute('aria-expanded', 'false');
      this.input?.removeAttribute('aria-activedescendant');
      this.options?.forEach(o => o.setAttribute('aria-selected', 'false'));
      this.active = -1;
      if (this.status) this.status.textContent = '';
    }
    schedule() {
      this.stop(); const term = this.input.value.trim();
      this.clearButton.hidden = !term;
      if (!term) return;
      const seq = this.sequence;
      this.timer = setTimeout(() => this.load(term, seq), 220);
    }
    async load(term, seq) {
      this.request = new AbortController();
      if (this.status) this.status.textContent = 'Recherche en cours…';
      try {
        const url = new URL(this.dataset.endpoint, location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('section_id', 'lbm-search-suggestions');
        url.searchParams.set('resources[type]', 'product,collection');
        url.searchParams.set('resources[limit]', '5');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { credentials: 'same-origin', signal: this.request.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Suggestions unavailable');
        const html = await response.text();
        if (seq !== this.sequence || this.input.value.trim() !== term || !this.contains(document.activeElement)) return;
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-lbm-results]');
        if (!source) throw new Error('Unexpected suggestions response');
        this.panel.replaceChildren(...Array.from(source.childNodes));
        this.options = Array.from(this.panel.querySelectorAll('a[role="option"]'));
        this.options.forEach((option, i) => { option.id = this.panel.id + '-item-' + i; });
        this.panel.hidden = !this.options.length;
        this.input.setAttribute('aria-expanded', String(this.options.length > 0));
        const count = Math.max(0, this.options.length - 1);
        if (this.status) this.status.textContent = count ? count + ' suggestions. Utilisez les flèches pour choisir ou Entrée pour rechercher.' : 'Aucune suggestion. Appuyez sur Entrée pour la recherche complète.';
      } catch (error) {
        if (error.name === 'AbortError' || seq !== this.sequence) return;
        this.panel.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        if (this.status) this.status.textContent = 'Appuyez sur Entrée pour rechercher.';
      }
    }
    key(event) {
      if (event.isComposing) return;
      if (event.key === 'Escape') { this.stop(); return; }
      if (this.panel.hidden || !this.options.length) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const n = this.options.length;
        this.active = event.key === 'ArrowDown' ? (this.active + 1) % n : (this.active <= 0 ? n - 1 : this.active - 1);
        this.options.forEach((o, i) => o.setAttribute('aria-selected', String(i === this.active)));
        const option = this.options[this.active];
        this.input.setAttribute('aria-activedescendant', option.id);
        option.scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && this.active >= 0) {
        event.preventDefault(); this.options[this.active].click();
      } else if (event.key === 'Tab') {
        this.stop();
      }
    }
  });
}
